module.exports = __webpack_public_path__ + "static/media/EAL.4dd52f51.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/EAL.jpg
// module id = 1729
// module chunks = 1